import { QUERY_KEYS } from "../../constants/queryKeys";
import { changeToUniqueArray } from "./functions/changeToUniqueArray";
import { convertToLegacyPortalSearchAvailabilityStatus } from "./functions/convertToLegacyPortalSearchAvailabilityStatus";
import { convertToLegacyPortalSearchEventType } from "./functions/convertToLegacyPortalSearchEventType";
import { getDateFromQueryString } from "./functions/getDateFromQueryString";

import type {
  LegacyPortalSearchAvailabilityStatus,
  LegacyPortalSearchEventType,
} from "@spwn-portal/grpc";

const {
  AVAILABILITY_STATUS,
  END_DATE,
  EVENT_TYPE,
  GENRE,
  KEYWORD,
  PREFECTURES,
  START_DATE,
} = QUERY_KEYS.SEARCH_CONDITIONS;

type Input = {
  search: string;
};
type DateData = Date | undefined;
type ArrayData = string[] | undefined;
type Output = {
  availabilityStatus: LegacyPortalSearchAvailabilityStatus[] | undefined;
  endDateFromQuery: DateData;
  eventTypeFromQuery: LegacyPortalSearchEventType[] | undefined;
  genreFromQuery: ArrayData;
  hasQueryForSearch: boolean;
  keywordFromQuery: string;
  prefectureCodesFromQuery: ArrayData;
  startDateFromQuery: DateData;
};
type ConvertQueryToSearchCondition = (input: Input) => Output;

const RETURN_DATA_WHEN_NO_QUERY: Output = {
  availabilityStatus: undefined,
  endDateFromQuery: undefined,
  eventTypeFromQuery: undefined,
  genreFromQuery: undefined,
  hasQueryForSearch: false,
  keywordFromQuery: "",
  prefectureCodesFromQuery: undefined,
  startDateFromQuery: undefined,
};

export const convertQueryToSearchCondition: ConvertQueryToSearchCondition = (
  input
) => {
  const { search } = input;
  const queryParameters = new URLSearchParams(search);
  const hasQueryForSearch = Object.values(QUERY_KEYS.SEARCH_CONDITIONS).some(
    (key) => queryParameters.get(key) !== null
  );

  if (!hasQueryForSearch) return RETURN_DATA_WHEN_NO_QUERY;

  const keywordFromQuery = queryParameters.get(KEYWORD) ?? "";
  const startDateFromQuery = getDateFromQueryString(
    queryParameters.get(START_DATE)
  );
  const endDateFromQuery = getDateFromQueryString(
    queryParameters.get(END_DATE)
  );
  const genreFromQuery = changeToUniqueArray(queryParameters.getAll(GENRE));
  const eventTypeFromQuery = changeToUniqueArray(
    queryParameters.getAll(EVENT_TYPE)
  )?.reduce(convertToLegacyPortalSearchEventType, []);
  const availabilityStatus = changeToUniqueArray(
    queryParameters.getAll(AVAILABILITY_STATUS)
  )?.reduce(convertToLegacyPortalSearchAvailabilityStatus, []);
  const prefectureCodesFromQuery = changeToUniqueArray(
    queryParameters.getAll(PREFECTURES)
  );

  return {
    availabilityStatus,
    endDateFromQuery,
    eventTypeFromQuery,
    genreFromQuery,
    hasQueryForSearch,
    keywordFromQuery,
    prefectureCodesFromQuery,
    startDateFromQuery,
  };
};
